/** Appends a later Pitch connection page onto the accumulated read. */
import type { ScoutingGetWatchlistPitchQuery } from "@/generated/graphql";

/**
 * Appends the next connection page onto the accumulated read.
 * @param previous - Accumulated read.
 * @param next - Freshly fetched page.
 * @returns Read carrying every loaded edge and the newest page info.
 */
export const appendPitchPage = (
  previous: ScoutingGetWatchlistPitchQuery,
  next: ScoutingGetWatchlistPitchQuery
): ScoutingGetWatchlistPitchQuery => {
  const previousPitch = previous.getWatchlistPitch;
  const nextPitch = next.getWatchlistPitch;
  if (!previousPitch || !nextPitch) return previous;
  return {
    ...previous,
    getWatchlistPitch: {
      ...nextPitch,
      members: {
        ...nextPitch.members,
        edges: [...previousPitch.members.edges, ...nextPitch.members.edges],
      },
    },
  };
};
